import Model from "./Model";

export const SituacaoEtapaType = {
  ATIVA: 1,
  DESATIVADA: 0,
};

export default class Etapa extends Model {
  constructor(franquia) {
    super();
    Object.assign(this, franquia);
  }

  get ativa() {
    return this.situacao === SituacaoEtapaType.ATIVA;
  }

  get desativada() {
    return this.situacao === SituacaoEtapaType.DESATIVADA;
  }
}
